<template>
	<div class="sharing" v-b-tooltip.hover :title="copied ? 'Link copiado' : 'Copiar link'">
		<div class="icons">
			<ShareNetwork network="facebook" :url="link" :title="title" hashtags="CobraTicket">
				<div class="btn"><i class="icon icon-social-facebook"></i></div>
			</ShareNetwork>
			<ShareNetwork network="twitter" :url="link" :title="title" hashtags="CobraTicket">
				<div class="btn"><i class="icon icon-social-twitter"></i></div>
			</ShareNetwork>
			<ShareNetwork network="whatsapp" :url="link" :title="title">
				<div class="btn"><i class="icon icon-social-whatsapp-outline"></i></div>
			</ShareNetwork>
		</div>
		<div class="input" @click="copyLink">
			{{ link }}
		</div>
		<div class="icons">
			<div class="btn" id="copyButton" @click="copyLink">
				<i class="icon icon-clone" />
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "ShareLink",

	props: {
		link: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			copied: false
		}
	},
	methods: {
		copyLink() {
			const clipboardData =
				event.clipboardData || window.clipboardData || event.originalEvent?.clipboardData || navigator.clipboard
			this.copied = true

			clipboardData.writeText(this.link)

			setTimeout(() => {
				this.copied = false
			}, 3000)
		}
	}
}
</script>
<style scoped lang="scss">
.sharing {
	width: 100%;
	display: flex;
	align-items: center;
	background-color: #f3f3f3;
	border-radius: 6px !important;
	overflow: hidden;

	.icons {
		display: flex;
		align-items: center;
		justify-content: flex-start;

		border-radius: 0px !important;
		height: 50px;
		border-right: none;
		overflow: hidden;

		.btn {
			width: 40px;
			height: 50px;
			background-color: transparent;
			transition: all 0.3s;
			border: none;

			.icon {
				width: 32px;
				height: 32px;
				font-size: 20px;
			}
			.icon.icon-clone {
				font-size: 16px;
			}

			&:hover {
				background-color: #ddd;
			}
		}
	}

	.input {
		flex-grow: 1;
		display: flex;
		align-items: center;
		height: 50px;
		padding: 0px 12px;
	}
}
</style>
